"use strict";
/*
 * Copyright (C) 2024 Klaus Reimer <k@ailis.de>
 * See LICENSE.md for licensing information.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.decodeTileLayer = void 0;
const base64_js_1 = require("base64-js");
const fzstd_1 = require("fzstd");
const pako_1 = require("pako");
const AnyLayer_1 = require("./AnyLayer");
const Compression_1 = require("./Compression");
const Encoding_1 = require("./Encoding");
// Decoder implementations
const decoders = {
    [Encoding_1.Encoding.BASE64]: base64_js_1.toByteArray
};
// Decompressor implementations
const decompressors = {
    [Compression_1.Compression.NONE]: (data) => data,
    [Compression_1.Compression.ZLIB]: pako_1.inflate,
    [Compression_1.Compression.GZIP]: pako_1.ungzip,
    [Compression_1.Compression.ZSTD]: fzstd_1.decompress
};
/**
 * Decodes the given tile layer (if necessary) and returns the decoded tile layer.
 *
 * @param layer - The tile layer to decode.
 * @returns The decoded tile layer or the original layer if it was not encoded.
 */
function decodeTileLayer(layer) {
    if ((0, AnyLayer_1.isUnencodedTileLayer)(layer)) {
        // Nothing to decode
        return layer;
    }
    const decode = decoders[layer.encoding];
    const decompress = decompressors[layer.compression ?? Compression_1.Compression.NONE];
    const toArray = (data) => Array.from(new Uint32Array(data.buffer, data.byteOffset));
    return {
        ...layer,
        compression: Compression_1.Compression.NONE,
        encoding: Encoding_1.Encoding.CSV,
        data: layer.data != null ? toArray(decompress(decode(layer.data))) : undefined,
        chunks: layer.chunks?.map(chunk => ({ ...chunk, data: toArray(decompress(decode(chunk.data))) }))
    };
}
exports.decodeTileLayer = decodeTileLayer;
//# sourceMappingURL=decodeTileLayer.js.map